<template lang="pug">
  div
    //- v-progress-linear(:indeterminate="true")
    v-chip(:color="status" :dark="darkStatus" small) 
      span {{ name }}
</template>

<script>
export default {
  props: ['statusID', 'name'],
  computed: {
    darkStatus() {
      let color = null
      switch(this.statusID) {
        case 183: // Accepted
          color = true
          break
        case 184: // Error
          color = true
          break
        case 185: // Denied
          color = true
          break
        case 186: // Got Paid
          color = true
          break
        case 187: // Waiting For Appeal
          color = false
          break
        default:
          color = true
      }
      return color     
    },
    status() {
      let color = null
      switch(this.statusID) {
        case 183:
          color = 'info'
          break
        case 184:
          color = 'deep-purple accent-1'
          break
        case 185:
          color = 'red'
          break
        case 186:
          color = 'green accent-4'
          break
        case 187:
          color = 'yellow'
          break
        default:
          color = 'info'
      }
      return color     
    },
  }
}
</script>

<style scoped>
</style>